import {FC, useEffect} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useAuth} from '../../../../../hooks/useAuth'
import {getDocsConfig} from '../../../../central/services/configDocument.service'

interface Props {
  prevStep: () => void
  nextStep: () => void
}

const FormStep0Parking: FC<Props> = ({prevStep, nextStep}) => {
  const {register, setValue} = useFormContext()
  const operationType = useWatch({name: 'operationType'})

  const {user} = useAuth()

  const getConfigDocumentList = async () => {
    try {
      if (user.lstSites.length > 0) {
        const {data: response} = await getDocsConfig({SiteId: user.lstSites[0].SiteId}, 1)
        if (!response.error) {
          if (response.data.length > 0) {
            setValue('validateString', response.data[0])
          }
        }
      }
    } catch (error) {}
  }

  const handleClick = (value: string) => {
    setValue('operationType', value)
    nextStep()
  }

  useEffect(() => {
    getConfigDocumentList()
    setValue('operationType', '')
  }, [])

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder d-flex align-items-center text-dark'>Bienvenido</h2>
        <div className='fw-bold fs-6'>¿Qué operación desea realizar?</div>
      </div>

      <div className='fv-row'>
        <div className='row'>
          <div className='col-lg-6'>
            <input
              type='radio'
              className='btn-check'
              {...register('operationType')}
              value='checkin'
              id='kt_create_account_form_account_type_personal'
            />
            <label
              className={`btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10 ${
                operationType === 'checkin' ? 'active' : ''
              }`}
              htmlFor='kt_create_account_form_account_type_personal'
              onClick={() => handleClick('checkin')}
            >
              <KTSVG
                path='/media/icons/duotune/communication/com005.svg'
                className='svg-icon-3x me-5'
              />
              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Check In</span>
              </span>
            </label>
          </div>

          <div className='col-lg-6'>
            <input
              type='radio'
              className='btn-check'
              {...register('operationType')}
              value='checkout'
              id='kt_create_account_form_account_type_corporate'
            />
            <label
              className={`btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center ${
                operationType === 'checkout' ? 'active' : ''
              }`}
              htmlFor='kt_create_account_form_account_type_corporate'
              onClick={() => handleClick('checkout')}
            >
              <KTSVG
                path='/media/icons/duotune/communication/com005.svg'
                className='svg-icon-3x me-5'
              />

              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Check Out</span>
              </span>
            </label>
          </div>
          {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
        </div>
      </div>
    </div>
  )
}

export {FormStep0Parking}
